import React from 'react';
import EmailBauApp from "./bau/index";

// conceptName = 'BAU' | 'concept1' | ... | 'VerizonProgress' (multi-cell: cell = 1..4)
const App = ({ conceptName, respondentKind, cell }) => (
  <EmailBauApp conceptName={ conceptName } respondentKind={ respondentKind } cell={ cell } />
);

export default App;
